import { contestConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { commonService } from "../_services";
import { alertActions } from ".";

export const contestsActions = {
  saveContest,
  getContestsList,
  deleteContest
};

//-- Login function
function saveContest(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(contestConstants.CONTEST_ADDED_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      contestData => {
        dispatch(commonAction.success(contestConstants.CONTEST_ADDED_SUCCESS, contestData));
      },
      error => {
        dispatch(commonAction.failure(contestConstants.CONTEST_ADDED_FAILURE, error));
        // dispatch(alertActions.error(error.response.data.error));
      }
    );
  };
}

//-- getContestsList
function getContestsList(apiName, contestData) {

  return dispatch => {

      dispatch(
          commonAction.request(contestConstants.CONTEST_LIST_REQUEST, contestData)
      );
      commonService.withTokenPut(apiName, contestData).then(
          notification => {

              dispatch(
                  commonAction.success(contestConstants.CONTEST_LIST_SUCCESS, notification)
              );
          },
          error => {
              dispatch(
                  commonAction.failure(contestConstants.CONTEST_LIST_ERROR, error)
              );
              dispatch(alertActions.error(error.response.data.error));
          }
      );
  };
}




//delete category
function deleteContest(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(contestConstants.CONTEST_DELETE_REQUEST, catObj));
    commonService.withTokenPut(apiName, catObj).then(
      contestData => {
        dispatch(commonAction.success(contestConstants.CONTEST_DELETE_SUCCESS, contestData));
      },
      error => {
        dispatch(commonAction.failure(contestConstants.CONTEST_DELETE_FAILURE, error));
      }
    );
  };
}